import { fadeOut } from './helpers';
export default function setupHeaderBehavior() {
    const header = document.querySelector('.site-header');
    const menu = document.querySelector('.js--menu');
    const toggleMenuButton = document.querySelector('.js--toggle-menu');
    let lastScrollTop = 0;
    function handleScroll() {
        const currentScroll = window.scrollY;
        if (currentScroll > 50) {
            header.classList.add('scroll-header');
        }
        else {
            header.classList.remove('scroll-header');
        }
        if (currentScroll > 500) {
            if (currentScroll > lastScrollTop) {
                header.classList.add('hide-header');
            }
            else {
                header.classList.remove('hide-header');
            }
        }
        else {
            header.classList.remove('hide-header');
        }
        lastScrollTop = currentScroll;
    }
    function toggleMenu() {
        if (!toggleMenuButton)
            return;
        toggleMenuButton.classList.toggle('active');
        header.classList.toggle('menu-open');
    }
    function closeMenuOnClickOutside(event) {
        if (menu && toggleMenuButton) {
            if (!header.contains(event.target) && !toggleMenuButton.contains(event.target)) {
                if (toggleMenuButton.classList.contains('active')) {
                    fadeOut(menu);
                    toggleMenuButton.classList.remove('active');
                    setTimeout(() => {
                        header.classList.remove('menu-open');
                    }, 300);
                }
            }
        }
    }
    if (header) {
        handleScroll();
        window.addEventListener('scroll', handleScroll);
        if (menu && toggleMenuButton) {
            toggleMenuButton.addEventListener('click', toggleMenu);
            document.addEventListener('click', closeMenuOnClickOutside, true);
            const menuLinks = menu.querySelectorAll('a');
            menuLinks.forEach((link) => {
                link.addEventListener('click', () => {
                    if (toggleMenuButton.classList.contains('active')) {
                        fadeOut(menu);
                        toggleMenuButton.classList.remove('active');
                        setTimeout(() => {
                            header.classList.remove('menu-open');
                        }, 300);
                    }
                });
            });
        }
    }
}
